exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart[data-v-54eace36]{background-color:#fff;width:778px;border:1px solid #979797}.cart .my-title[data-v-54eace36]{padding:23px 42px}.cart .my-title span[data-v-54eace36]{margin-left:20px;font-size:24px}.cart .my-title .title-right[data-v-54eace36]{cursor:pointer}.cart .total[data-v-54eace36]{background-color:#26262a;color:#fff}.cart .total .container[data-v-54eace36]{padding:37px 69px}.cart .call-checkout a[data-v-54eace36]{width:100%;padding:36px 69px}", ""]);

// exports
